import { ScheduledJob, IScheduledJob } from "../ScheduledJob"
import { ScheduledJobTypeEnum } from "../ScheduledJobTypeEnum"
import { IRestaurantLimitDowngradedData } from "./IRestaurantLimitDowngradedData"

export interface IRestaurantLimitDowngraded extends IScheduledJob {
  data: IRestaurantLimitDowngradedData
}

export class RestaurantLimitDowngraded extends ScheduledJob implements IRestaurantLimitDowngraded {
  constructor(
    public scheduledFor: Date,
    public data: IRestaurantLimitDowngradedData
  ) {
    super(ScheduledJobTypeEnum.DOWNGRADED_LIMIT, scheduledFor)
  }

  type = ScheduledJobTypeEnum.DOWNGRADED_LIMIT
}
